export default __webpack_public_path__ + "static/solar_hunter-49f716.svg";